import React from "react";
import { Routes, Route } from "react-router-dom";
import Contacts from "./Pages/Contacts";
import Home from "./Pages/Home";
import Projects from "./Pages/Projects";
import Skills from "./Pages/Skills";
import About from "./Pages/About";
import Layout from "./components/Layout/Layout";

const App = () => {
  return (
    <>
      <Layout></Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/skills" element={<Skills />} />
        <Route path="/contacts" element={<Contacts />} />
      </Routes>
    </>
  );
};

export default App;
